import { EVENTS_FILTER, EVENTS_TIMETABLE, LOGIN } from '../../constants/actions';
import { LOCATION_CHANGE } from 'react-router-redux';
import { hasASelection } from '../../selectors/events/filter';
import { find, forEach } from 'lodash';

const initialState = {
    viewFilterOpen: false,
    filterOpen: false,
    partners: [],

    filtersOpen: false,
    activityOpen: false,
    sortBy: 'artistName',
    order: 'asc',
    artists: [],
    stages: [],
    live: [],
    nonLinear: [],

    selectedPartner: null,
    liveView: true,
    listView: false
};

function search(state = initialState, action) {
    switch (action.type) {
        case EVENTS_TIMETABLE.FETCH_OK:
            const partners = action.partners;
            const lastPartnerId = action.lastPartnerId;
            const lastPartner = find(partners, p => p.id === lastPartnerId);
            return {
                ...state,
                partners: partners,
                selectedPartner: (lastPartner && lastPartner.id) || (partners[0] && partners[0].id)
            };
        case EVENTS_FILTER.OPEN:
            return { ...state, [action.field]: true };
        case EVENTS_FILTER.CLOSE:
            return { ...state, [action.field]: false };
        case EVENTS_FILTER.SET:
            return { ...state, [action.field]: action.value };
        case EVENTS_FILTER.SELECT:
            return { ...state, selectedPartner: action.selection, open: false };
        case EVENTS_FILTER.TOGGLE_ONE:
            return { ...state, [action.field]: !state[action.field] };
        case EVENTS_FILTER.TOGGLE_ALL:
            const deselectAll = hasASelection(state.clearance, action.group);
            const newClearance = {};
            forEach(state.clearance, (v, k) => {
                if (k.startsWith(action.group)) {
                    newClearance[k] = deselectAll ? false : true;
                } else {
                    newClearance[k] = state.clearance[k];
                }
            });
            return { ...state, clearance: newClearance };
        case EVENTS_FILTER.TOGGLE:
            return {
                ...state,
                [action.collection]: {
                    ...state[action.collection],
                    [action.key]: !state[action.collection][action.key]
                }
            };
        case LOGIN.CANCEL:
        case LOCATION_CHANGE:
            return initialState;
        default:
            return state;
    }
}

export default search;



// WEBPACK FOOTER //
// ./src/reducers/events/filter.js